// removed by extract-text-webpack-plugin
module.exports = {"SlidegalleryItem":"SlidegalleryItem","SlidegalleryItem__video-wrapper":"SlidegalleryItem__video-wrapper","YoutubePlayer":"YoutubePlayer","SlidegalleryItem__photo-info-wrapper":"SlidegalleryItem__photo-info-wrapper","SlidegalleryItem__image-wrapper":"SlidegalleryItem__image-wrapper","SlidegalleryItem__image-pc":"SlidegalleryItem__image-pc","SlidegalleryItem__image-mb":"SlidegalleryItem__image-mb","PhotoInfo":"PhotoInfo"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/slidegallery-item/styles.css
// module id = 818
// module chunks = 0 1